import { render, staticRenderFns } from "./ExcMobDropdownItem.vue?vue&type=template&id=87d05806&scoped=true&"
import script from "./ExcMobDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ExcMobDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcMobDropdownItem.vue?vue&type=style&index=0&id=87d05806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d05806",
  null
  
)

export default component.exports